/**
 * Vorauswahl einer Menge in den Mengen-Chips (`blocks/variant-chips.liquid`).
 *
 * Liquid gibt den Marker `[data-cd-preselect]` nur aus, wenn
 *   - am Block eine SKU gesetzt ist, die zu einer VERFÜGBAREN Variante gehört,
 *   - die Adresse KEIN `?variant=` trägt (dann gewinnt der Deep-Link),
 *   - und die Variante nicht ohnehin schon gewählt ist.
 *
 * Dieses Skript schaltet dann nur den passenden Radio um und löst `change`
 * aus. Alles Weitere — Preis, Kaufknopf, Galerie, Sticky-Leiste — erledigt
 * Horizons `assets/variant-picker.js` genau wie bei einem Klick. Kein eigenes
 * Nachladen, kein eigenes Morphing.
 *
 * Gemessen 2026-10-02: Die Adresse bekommt dabei KEIN `?variant=` (anders als
 * bei einem echten Klick nicht beobachtet), und bis etwa 0,45 s nach
 * Navigationsbeginn steht sichtbar die 50er-Variante — der Server liefert sie
 * aus, das Umschalten wartet auf Horizons Nachladen (~130 ms).
 *
 * ⚠️ Der Marker steht direkt HINTER dem `<variant-picker>` desselben Blocks
 * (der Block hat `"tag": null`, es gibt keine Hülle). Gesucht wird deshalb im
 * vorangehenden Geschwister, nicht seitenweit — sonst träfe eine zweite
 * Chip-Reihe auf derselben Seite die falsche Auswahl.
 */

const markers = document.querySelectorAll('[data-cd-preselect]');

if (markers.length && !new URL(window.location.href).searchParams.has('variant')) {
  customElements.whenDefined('variant-picker').then(() => {
    for (const marker of markers) {
      if (!(marker instanceof HTMLElement) || marker.dataset.cdPreselectDone) continue;
      marker.dataset.cdPreselectDone = 'true';

      const picker = marker.previousElementSibling;
      if (!picker || picker.tagName !== 'VARIANT-PICKER') continue;

      const input = picker.querySelector(`input[data-variant-id="${CSS.escape(marker.dataset.cdPreselect ?? '')}"]`);
      if (!(input instanceof HTMLInputElement) || input.checked) continue;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}
